import { render, staticRenderFns } from "./ImportCompletedModal.vue?vue&type=template&id=2d164030"
import script from "./ImportCompletedModal.vue?vue&type=script&lang=ts"
export * from "./ImportCompletedModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports